import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BenefitIcon, BenefitKey } from '../../../lib/components/compound/dataDisplay/benefitIcon';
import { CustomBenefitIcon } from '../../../lib/components/compound/dataDisplay/customBenefitIcon';
import { IconEnum } from '@pxtra-client-lib-legacy/gen';

export type BenefitIconStyle = 'contained' | 'stroke';

interface Props {
  benefitKey: BenefitKey | string;
  benefitName?: string;
  benefitIcon?: IconEnum;
  variant?: BenefitIconStyle;
  onClick?: () => void;
  custom?: boolean;
}

export const BenefitCell: FC<Props> = ({
  benefitKey,
  benefitName,
  benefitIcon,
  onClick,
  variant = 'stroke',
  custom
}) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: 'flex',
        columnGap: '0.5rem',
        alignItems: 'center',
        '&:hover': {
          cursor: onClick ? 'pointer' : 'unset',
          color: onClick ? 'primary.dark' : 'unset'
        }
      }}
      onClick={onClick}
    >
      {custom ? (
        <>
          <CustomBenefitIcon
            iconKey={benefitIcon as IconEnum}
            size={32}
            backgroundColor={variant === 'contained' ? 'heaven.main' : 'none'}
            color={variant === 'contained' ? 'white' : 'heaven.main'}
            sx={{ marginLeft: '-.5rem' }}
          />
          <Typography variant="body1" color="inherit" paddingLeft={0.75}>
            {benefitName}
          </Typography>
        </>
      ) : (
        <>
          <BenefitIcon
            benefitKey={benefitKey as BenefitKey}
            size={32}
            backgroundColor={variant === 'contained' ? 'heaven.main' : 'none'}
            color={variant === 'contained' ? 'white' : 'heaven.main'}
            sx={{ marginLeft: '-.5rem' }}
          />
          <Typography variant="body1" color="inherit" paddingLeft={0.75}>
            {t(`benefits:${benefitKey}`)}
          </Typography>
        </>
      )}
    </Box>
  );
};
